<template>
  <v-container fluid>
    <v-layout>
      <v-flex>
        <v-form>
          <v-flex xs6 sm4 class="pa-1 pb-3">
            <h3>
              Invitation file must contain ""Attendee type", "Booth", "Number of tickets", "Number of vouchers", "Email", "Company name" columns.
              Accepted formats <span>.csv/.xlsx</span>.
            </h3>
          </v-flex>
          <v-flex class="mb-5" xs12 sm3 justify-center>
            <v-btn
              v-if="file"
              color="error"
              raised
              @click="removeFile"
            >
              Remove file
            </v-btn>
            <v-btn
              v-if="file"
              color="success"
              raised
              @click="uploadFile"
            >
              Upload file
            </v-btn>
            <e-upload
              v-else
              :extensions="['.csv', '.xlsx']"
              :directUpload="false"
              @filePicked="onFilePicked"
              padding="pa-0"
            />
          </v-flex>

          <v-data-table
            v-if="getBatchedInvitationsItems"
            :headers="headers"
            :items="getBatchedInvitationsItems"
            class="elevation-1 wrap mb-5"
            :pagination.sync="pagination"
            :rows-per-page-items="pageRows"
            :loading="loading"
            item-key="id"
            :disable-initial-sort="true"
            v-model="selected">
            <template slot="headers" slot-scope="props">
              <tr>
                <th>
                  <!-- <v-icon @click="selectAllItems" title='Select all' color="blue" style="cursor: pointer">check_box</v-icon> -->
                  <v-icon @click="selectNotSentItems" title='Select not sent' color="blue" style="cursor: pointer">check</v-icon>
                </th>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="['column', header.sortable ? 'sortable' : '', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                  @click="changeSort(header)"
                >
                  <v-icon v-if="header.sortable" small>arrow_upward</v-icon>
                  {{ header.text }}
                </th>
              </tr>
            </template>

            <template slot="items" slot-scope="props">
              <tr :class="['aligned-center', isNotCompleted(props.item) ? 'status-Incomplete' : '']">
                <td>
                  <v-checkbox
                    :disabled='isNotCompleted(props.item)'
                    v-model="selected"
                    :value="props.item.id"
                    primary
                    hide-details
                  />
                </td>
                <td class="py-4">{{ getStatus(props.item.sendingStatus) }}</td>
                <td class="py-4">{{ getType(props.item).title }}</td>
                <td class="py-4">{{ props.item.boothNumber }}</td>
                <td class="py-4">{{ props.item.ticketsCount }}</td>
                <td class="py-4">{{ props.item.lunchVouchers }}</td>
                <td class="py-4">{{ props.item.requestLunchVouchers }}</td>
                <td class="py-4">{{ props.item.receiverEmail }}</td>
                <td class="py-4">{{ props.item.company }}</td>
                <td class="py-4">
                  <v-btn
                    color="blue"
                    fab flat
                    slot="activator"
                    @click.stop="showInvited(props.item.code)">
                    <v-icon>person</v-icon>
                  </v-btn>
                </td>
                <td class="py-4">
                  <v-btn
                    color="lime"
                    fab flat
                    slot="activator"
                    @click.stop="editItem(props.item)">
                    <v-icon>edit</v-icon>
                  </v-btn>
                </td>
                <td class="py-4">
                  <v-btn
                    color="red"
                    fab flat
                    slot="activator"
                    @click.stop="deleteItem(props.item.id)">
                    <v-icon>delete</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>

          <v-layout mb-5 row wrap>
            <v-flex md5 mr-5>

              <h3>Invitation Settings Information</h3>

              <content-field
                :label="invitationName.label"
                :hint="invitationName.hint"
                :error="$v.invitationName.value"
                @blur="$v.invitationName.value.$touch()"
                v-model="invitationName.value"
                required
              />

              <v-select
                v-model="templateKey.value"
                :error-messages="isValid($v.templateKey.value)"
                :items="vipInvitationTemplatesList"
                label="Vip Inviatiom email template"
                item-value="templateKey"
                item-text="templateKey"
              />

              <v-select
                :disabled='true'
                :label="paymentType.label"
                :items="typesOfPayment"
                v-model="paymentType.value"
                :error="$v.paymentType.value.$invalid"
                @blur="$v.paymentType.value.$touch()"
                :error-messages="isValid($v.paymentType.value)"
              />

              <v-select
                :label="packageId.label"
                :items="packages"
                v-model="packageId.value"
                item-text="name"
                item-value="id"
                :error="$v.packageId.value.$invalid"
                @blur="$v.packageId.value.$touch()"
                :error-messages="isValid($v.packageId.value)"
              />

              <content-field
                :label="packagePrice.label"
                :key="packagePrice.label"
                :disabled="true"
                :value="currentPrice"
              />

              <content-field
                :label="messageLimit.label"
                :key="messageLimit.label"
                :hint="messageLimit.hint"
                :error="$v.messageLimit.value"
                @blur="$v.messageLimit.value.$touch()"
                v-model="messageLimit.value"
                required
              />
            </v-flex>
            <v-flex md5 mr-5>
              <h3>Package Email Settings</h3>
              <v-flex mt-2>
                <v-layout row wrap>
                  <v-flex>
                    <v-select
                      v-model="packageEmailTemplates.confirmationEmailTemplateName"
                      :error-messages="isValid($v.packageEmailTemplates.confirmationEmailTemplateName)"
                      :items="registrationSuccesTemplatesList"
                      label="Confirmation email template"
                      item-value="templateKey"
                      item-text="templateKey"
                    />
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex>
                    <v-select
                      v-model="packageEmailTemplates.failedPaymentEmailTemplateName"
                      :items="registrationFailtureTemplatesList"
                      :error-messages="isValid($v.packageEmailTemplates.failedPaymentEmailTemplateName)"
                      label="Failed payment email template"
                      item-value="templateKey"
                      item-text="templateKey"
                    />
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex>
                    <v-select
                      :items="multipleTicketsSuccessBuyTemplatesList"
                      v-model="packageEmailTemplates.multiUserConfirmationEmailTemplateKey"
                      :error-messages="isValid($v.packageEmailTemplates.multiUserConfirmationEmailTemplateKey)"
                      label="Multiple user confirmation email template"
                      item-value="templateKey"
                      item-text="templateKey"
                    />
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex>
                    <v-select
                      :items="multipleTicketsFailedBuyTemplatesList"
                      v-model="packageEmailTemplates.multiUserFailedPaymentEmailTemplateKey"
                      :error-messages="isValid($v.packageEmailTemplates.multiUserFailedPaymentEmailTemplateKey)"
                      label="Multiple user failed email template"
                      item-value="templateKey"
                      item-text="templateKey"
                    />
                  </v-flex>
                </v-layout>

                <!-- <v-layout wrap row v-if="arePredefinedActivitiesExist">
                  <v-flex md12>
                    <h3>Change predefined activities: </h3>
                    <v-switch
                      label="Change activities"
                      v-model="areActivitiesChanged"
                    />
                    <v-layout row wrap v-if="areActivitiesChanged">
                      <v-flex xs12 class="my-4">
                        <div v-for="(value) in predefinedActivity" :key="`predefined-activity-${value.id}`">
                          <v-checkbox
                            v-model="selectedPredefinedActivities"
                            :label="value.title"
                            :value="value.id"
                          />
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout> -->
              </v-flex>
            </v-flex>
          </v-layout>

          <v-layout mb-5 row wrap>
            <v-flex md5 mr-5>
              <h3>Additional Features</h3>
              <v-flex mt-2>

                <v-layout row wrap>
                  <v-flex xs12 sm4 mt-4><p>{{isKillerFeatureEnabled.label}}</p></v-flex>
                  <v-flex xs12 sm8>
                    <v-radio-group v-model="isKillerFeatureEnabled.value" row>
                      <v-radio
                        :label="isKillerFeatureEnabled.options[0].text"
                        :key="isKillerFeatureEnabled.options[0].value"
                        :value="isKillerFeatureEnabled.options[0].value"
                      />
                      <v-radio
                        :label="isKillerFeatureEnabled.options[1].text"
                        :key="isKillerFeatureEnabled.options[1].value"
                        :value="isKillerFeatureEnabled.options[1].value"
                      />
                    </v-radio-group>
                  </v-flex>
                </v-layout>

                <v-layout row wrap>
                  <v-flex xs12 sm4 mt-4><p>{{isPaidOffline.label}}</p></v-flex>
                  <v-flex xs12 sm8>
                    <v-radio-group v-model="isPaidOffline.value" row>
                      <v-radio
                        :label="isPaidOffline.options[0].text"
                        :key="isPaidOffline.options[0].value"
                        :value="isPaidOffline.options[0].value"
                      />
                      <v-radio
                        :label="isPaidOffline.options[1].text"
                        :key="isPaidOffline.options[1].value"
                        :value="isPaidOffline.options[1].value"
                      />
                    </v-radio-group>
                  </v-flex>
                </v-layout>

              </v-flex>
            </v-flex>

            <v-flex md5 v-if="showDiscountField">
              <h3>Discount Settings</h3>
              <v-flex mt-2>

                <v-radio-group v-model="discount" row>
                  <v-radio
                    :label="discountTypes.discountInCurrency.label"
                    :key="discountTypes.discountInCurrency.name"
                    :value="discountTypes.discountInCurrency.name"
                  />
                  <v-radio
                    :label="discountTypes.discountInPercent.label"
                    :key="discountTypes.discountInPercent.name"
                    :value="discountTypes.discountInPercent.name"
                  />
                </v-radio-group>

                <content-field
                  :label="discountTypes[discount].label"
                  :key="discountTypes[discount].name"
                  :hint="discountTypes[discount].hint"
                  v-model="discountTypes[discount].value"
                  :error="$v.discountTypes[discount].value"
                  @input="$v.discountTypes[discount].value.$touch()"
                  @blur="$v.discountTypes[discount].value.$touch()"
                  :customErrorMessages="errorMessages"
                  required
                />

                <content-field
                  :label="discountTypes.newPrice.label"
                  :key="discountTypes.newPrice.label"
                  :disabled="true"
                  :value="newPriceAfterDiscount"
                />

                <p>Price without VatID</p>

                <content-field
                  :label="discountTypes.newPriceWithVatID.label"
                  :key="discountTypes.newPriceWithVatID.label"
                  :disabled="true"
                  :value="priceWithVatId"
                />

              </v-flex>
            </v-flex>
          </v-layout>

          <v-layout mt-5>
            <v-btn
              :disabled="$v.$invalid || !selected.length || !isSameStatusSend"
              @click="submit('send')"
              color="success"
            >
              Send
            </v-btn>
            <v-btn
              :disabled="$v.$invalid || !selected.length || !isSameStatusResend"
              @click="submit('reSend')"
              color="success"
            >
              Resend
            </v-btn>
            <v-btn
              @click="clear"
              color="error"
            >
              clear
            </v-btn>
          </v-layout>

        </v-form>
      </v-flex>
    </v-layout>
    <br>
    <div class='edit-popup-bg' v-if='currentEditItem.id'></div>
    <div
      :class="['edit-popup', currentEditItem.id ? 'visible-popup' : '']" >
      <h1>Edit invitation item for {{currentEditItem.receiverEmail}}</h1>

        <v-select
          v-model="currentEditItem.selectedAttendeeTypeIdByManager"
          :items="getVIPAttendeeTypes"
          label="Attendee type"
          item-text="title"
          item-value="id"
        />

        <v-text-field
            label="Email"
            type="email"
            v-model="currentEditItem.receiverEmail"
          ></v-text-field>

        <v-text-field
            label="Booth"
            v-model="currentEditItem.boothNumber"
          ></v-text-field>

        <v-text-field
            label="Number of tickets"
            type="numeric"
            v-model="currentEditItem.ticketsCount"
          ></v-text-field>

        <v-text-field
          label="Lunch vouchers"
          type="numeric"
          v-model="currentEditItem.lunchVouchers"
        ></v-text-field>

        <v-text-field
          label="Request Lunch vouchers"
          type="numeric"
          v-model="currentEditItem.requestLunchVouchers"
        ></v-text-field>

        <v-text-field
            label="Company name"
            v-model="currentEditItem.company"
          ></v-text-field>

      <v-btn
        :disabled="!isValidItem(currentEditItem)"
        @click="saveEdit"
        color="success">
        save
      </v-btn>

      <v-btn
        @click="closeEdit"
        color="error">
        cancel
      </v-btn>
    </div>

    <v-dialog v-model="loadedCurrentAttendees" max-width="600px">
      <v-card class="pa-2" >
        <v-card-title>
          <span class="headline mb-0 text-md-center">Registered attendees</span>
            <div>
              <v-data-table
                hide-actions
                v-if="loadedCurrentAttendees"
                :headers="attendeesHeaders"
                :items="getCurrentInvitedAttendees"
                class="elevation-1"
              >
                <template slot="items" slot-scope="props">
                  <td class="py-4">{{ props.item.firstName }}</td>
                  <td class="py-4">{{ props.item.lastName }}</td>
                  <td class="py-4">{{ props.item.email }}</td>
                  <td class="py-4">{{ props.item.status }}</td>
                </template>
              </v-data-table>
            </div>
        </v-card-title>
        <v-card-actions>
          <v-btn color="error" flat @click="hideCurrentAttendees">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import { required, maxLength, email, numeric, between, maxValue, minValue, alpha } from 'vuelidate/lib/validators'
  import { mapGetters, mapActions } from 'vuex'
  import ESmallModal from './modal'
  import EUpload from '@/components/shared/Upload'
  import mixins from '@/utils/mixins'

  import {
    map,
    mapObjIndexed,
    prop,
    clone,
    filter,
    equals,
    find,
    assocPath,
    propEq,
    path,
    pathOr,
    isEmpty
  } from 'ramda'

  const typesOfPayment = ['Group', 'Single']
  const statuses = {
    1: 'Uploaded',
    2: 'Sent',
    3: 'Processing',
    4: 'Incomplete',
    5: 'NoChanged',
    6: 'Updated'
  }

  export default {
    name: 'BatchedInvitation',
    components: {
      ESmallModal,
      EUpload
    },
    mixins: [mixins.emailTemplates],
    data () {
      const defaultRows = {"text":"All","value":-1}
      return {
        loadedCurrentAttendees: false,
        file: null,
        currentEditItem: {},
        loading: true,
        selected: [],
        pagination: {
          rowsPerPage: defaultRows,
          sortBy: 'updateDate',
          descending: true,
          page: 1,
          totalItems: 0
        },
        pageRows: [defaultRows],
        attendeesHeaders: [
          { text: 'First name', value: 'firstName', search: false, sortable: false, width: 30 },
          { text: 'Last name', value: 'firstName', search: false, sortable: false, width: 30 },
          { text: 'Email', value: 'email', search: false, sortable: false, width: 30 },
          { text: 'Status', value: 'status', search: false, sortable: false, width: 30 },
          // { text: 'Company', value: 'company', search: false, sortable: false, width: 30 },
        ],
        headers: [
          { text: 'Status', value: 'sendingStatus', search: false, sortable: true, width: 30 },
          { text: 'Attendee type', value: 'selectedAttendeeTypeIdByManager', search: false, sortable: false, width: 30 },
          { text: 'Booth', value: 'boothNumber', search: true, sortable: true, width: 30 },
          { text: 'Number of tickets', value: 'ticketsCount', search: false, sortable: false, width: 30 },
          { text: 'Lunch Vouchers', value: 'lunchVouchers', search: false, sortable: true, width: 30 },
          { text: 'Request Lunch Vouchers', value: 'requestLunchVouchers', search: false, sortable: true, width: 30 },
          { text: 'Email', value: 'receiverEmail', search: true, sortable: true, width: 60 },
          { text: 'Company name', value: 'company', search: true, sortable: true, width: 60 },
          { text: 'Attendees', sortable: false, align: 'center', width: 30 },
          { text: 'Actions', sortable: false, align: 'center', width: 30 },
          { text: 'Delete', sortable: false, align: 'center', width: 30 }
        ],
        typesOfPayment,
        invitationName: {
          name: 'invitationName',
          label: 'Invitation name',
          hint: 'Please specify invitation title',
          value: ''
        },
        messageLimit: {
          name: 'messageLimit',
          label: 'Message Limit',
          hint: 'Please, enter message limit',
          value: 200
        },
        paymentType: {
          name: 'paymentType',
          label: 'Type of Payment Process',
          hint: 'Please, choose payment Type',
          value: typesOfPayment[0]
        },
        templateKey: { value: '' },
        packageId: { name: 'packageId', label: 'Package Id', hint: 'Please, enter package id', value: null },
        packagePrice: { name: 'packagePrice', label: 'Package Price' },
        discount: 'discountInCurrency',
        discountTypes: {
          discountInCurrency: {
            name: 'discountInCurrency',
            label: 'Discount in currency for each tickets',
            hint: 'Please, enter recipient\'s discount in currency',
            value: 0
          },
          discountInPercent: {
            name: 'discountInPercent',
            label: 'Discount in percent',
            hint: 'Please, enter discount in percent',
            value: 0
          },
          newPrice: { name: 'newPrice', label: 'New Price' },
          newPriceWithVatID: { name: 'newPriceWithVatID', label: 'New price without VatID' }
        },
        isKillerFeatureEnabled: {
          label: 'Killer feature',
          hint: 'Please, decide if killer feature is enabled',
          value: false,
          options: [{ text: 'enabled', value: true }, { text: 'disabled', value: false }]
        },
        isPaidOffline: {
          label: 'Paid offline',
          hint: 'Please, choose if recipient paid offline',
          value: false,
          options: [{ text: 'yes', value: true }, { text: 'no', value: false }]
        },
        packageEmailTemplates: {
          confirmationEmailTemplateName: '',
          failedPaymentEmailTemplateName: '',
          multiUserConfirmationEmailTemplateKey: '',
          multiUserFailedPaymentEmailTemplateKey: ''
        },
      packages: [],
        maxDiscountInCurrency: 0,
        currentPackage: null,
        areActivitiesChanged: false,
        selectedPredefinedActivities: []
      }
    },
    validations () {
      return {
        invitationName: { value: { required } },
        paymentType: { value: { required } },
        templateKey: { value: { required } },
        packageId: { value: { required } },
        messageLimit: { value: { required, numeric } },
        discountTypes: {
          discountInCurrency: {
            value: {
              maxValue: maxValue(this.maxDiscountInCurrency || 0),
              minValue: minValue(0)
            }
          },
          discountInPercent: { value: { between: between(0, 100) } }
        },
        packageEmailTemplates: {
          confirmationEmailTemplateName: { required },
          failedPaymentEmailTemplateName: { required },
          multiUserConfirmationEmailTemplateKey: { required },
          multiUserFailedPaymentEmailTemplateKey: { required }
        }
      }
    },
    computed: {
      ...mapGetters([
        'getVIPLetter',
        'enabledCategoriesList',
        'packagesList',
        'getVIPAttendeeTypes',
        'getSettings',
        'predefinedActivity',
        'categoriesList',
        'getCurrentInvitedAttendees',
        'getBatchedInvitationsItems'
      ]),
      totalItemsInTable () {
        return this.getBatchedInvitationsItems.length
      },
      arePredefinedActivitiesExist () {
        return this.predefinedActivity.length
      },
      showDiscountField () {
        return this.maxDiscountInCurrency > 0
      },
      errorMessages () {
        return [
          {
            type: 'between',
            message: 'This field should be between 0 and 100'
          },
          {
            type: 'maxValue',
            message: `This field should no more than ${this.maxDiscountInCurrency}`
          },
          {
            type: 'minValue',
            message: `This field should be more than 0`
          }
        ]
      },
      currentPrice () {
        return this.currentPackage
          ? parseFloat(parseFloat(this.currentPackage.price || 0).toFixed(2))
          : 0
      },
      newPriceAfterDiscount () {
        const discont = parseInt(pathOr(false, [this.discount, 'value'], this.discountTypes))
        const checkedDiscont = discont ? discont : 0
        const discountInCurrency = this.currentPrice - checkedDiscont
        const discountInPercent = this.currentPrice - this.currentPrice / 100 * checkedDiscont
        const priceForOne = this.discount === 'discountInCurrency' ? discountInCurrency : discountInPercent
        const priceWithCount = priceForOne * parseInt(path(['ticketsCount', 'value'], this))
        return priceWithCount ? parseFloat(priceWithCount.toFixed(2)) : ''
      },
      getVatId () {
        return pathOr(0, ['globalSetting', 'vatIdSettings', 'increasingPercent'], this.getSettings)
      },
      priceWithVatId () {
        const price = this.newPriceAfterDiscount + (this.newPriceAfterDiscount * this.getVatId)
        return parseFloat(parseFloat(price).toFixed(2))
      },
      calcMessageLimit () {
        return !isEmpty(this.currentPackage)
          ? pathOr(200, ['messagesLimit'], this.currentPackage)
          : this.messageLimit.value
      },
      invitationPredefinedActivities () {
        return this.areActivitiesChanged ? this.selectedPredefinedActivities : this.currentPackage.predefinedActivities
      },
      selectedStatuses () {
        let sendingStatuses = []
        this.selected.forEach(id => {
          if ( this.getBatchedInvitationsItems.find(item => item.id === id) ) {
            const item = this.getBatchedInvitationsItems.find(item => item.id === id)
            sendingStatuses.push(item.sendingStatus)
          }
        })
        return sendingStatuses
      },
      isSameStatusResend () {
        return (this.selectedStatuses.find(item => item == 1) || this.selectedStatuses.find(item => item == 4)) ? false : true
      },
      isSameStatusSend () {
        return (this.selectedStatuses.find(item => item == 2) || this.selectedStatuses.find(item => item == 3)) ? false : true
      }
    },
    watch: {
      discount (newVal, oldVal) {
        this.discountTypes[oldVal].value = 0
      },
      getVIPAttendeeTypes (newVal) {
        this.currentEditItem.selectedAttendeeTypeIdByManager = newVal[0].id // use this for table
      },
      packagesList (newVal) {
        this.packages = newVal
        this.packageId.value = this.packages[0].id
      },
      packageId: {
        handler (newVal) {
          if (!newVal) return
          this.currentPackage = find(item => equals(item.id, newVal.value), this.packages)
          this.maxDiscountInCurrency = this.currentPackage.price
          this.messageLimit.value = this.calcMessageLimit
        },
        deep: true
      }
    },
    methods: {
      ...mapActions([
        'closeLetterModal',
        'getEnabledCategoriesList',
        'getPackagesList',
        'fetchVIPAttendeeTypes',
        'getPredefinedActivity',
        'getCategoriesList',
        'fetchBatchedInvitations',
        'sendBatchedItemsTable',
        'saveBatchedInvitations',
        'fetchInvitedAttendeesByCode',
        'sendBatchedInvitations',
        'deleteBatchedInvitation',
        'reSendBatchedInvitations'
      ]),
      isNotCompleted (item) {
        return item.sendingStatus === 'Incomplete' || !this.isValidItem(item)
      },
      selectAllItems () {
        if (this.selected.length == this.getBatchedInvitationsItems.length) this.selected = []
        else this.selected = this.getBatchedInvitationsItems.map(item => item.id)
      },
      editItem (item) {
        this.currentEditItem = Object.assign({}, item)
      },
      deleteItem (id) {
        this.deleteBatchedInvitation(id)
      },
      async showInvited (code) {
        this.loadedCurrentAttendees = false
        await this.fetchInvitedAttendeesByCode(code)
        this.loadedCurrentAttendees = true
      },
      hideCurrentAttendees () {
        this.loadedCurrentAttendees = false
      },
      closeEdit () {
        this.currentEditItem = {}
      },
      async saveEdit () {
        const data = Object.assign({}, this.currentEditItem, {isAttendeeTypeRightParsed: true})
        await this.saveBatchedInvitations([data])
        await this.fetchBatchedInvitations()
        this.closeEdit()
      },
      getType (item, skipParsedCheck = false) {
        if (!skipParsedCheck && !item.isAttendeeTypeRightParsed) return {}
        return this.getVIPAttendeeTypes.find(i => i.id == item.selectedAttendeeTypeIdByManager) || {}
      },
      getStatus (i) {
        if (typeof(i) == 'number') {
          return statuses[i]
        } else {
          return i
        }
      },
      isValidItem (item) {
        const withEmail = this.getBatchedInvitationsItems.filter(i => (item.receiverEmail || '').toLowerCase() === (i.receiverEmail || '').toLowerCase())

        if (withEmail.length === 1) {
          if ((withEmail[0].id || '').toString() !== (item.id || '').toString()) return false
        } else if (withEmail.length > 1) {
          console.log('email should be unique')
          return false
        }

        return  !!this.getType(item, true).id &&
                !!item.boothNumber &&
                !!item.receiverEmail &&
                !!item.company
      },
      selectNotSentItems () {
        this.selected = this.getBatchedInvitationsItems
          .filter(item => item.sendingStatus == 'Uploaded' && this.isValidItem(item))
          .map(i => i.id)
      },
      changeSort (column) {
        if (!column.sortable) return
        if (this.pagination.sortBy === column.value) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = column.value
          this.pagination.descending = false
        }
      },
      isValid (validationItem) {
        return validationItem.$dirty && validationItem.$invalid
          ? ['This field is required']
          : []
      },
      onFilePicked (file) {
        this.file = file
      },
      removeFile () {
        this.file = null
      },
      uploadFile () {
        const formData = new window.FormData()
        formData.append('file', this.file)
        this.loading = true
        this.sendBatchedItemsTable(formData).then(() => {
          this.fetchBatchedInvitations().then(() => { this.loading = false })
        })
      },
      async submit (action = 'send') {
        try {
          this.$v.$touch()
          if (this.$v.$invalid) return
          if (this.selected.length < 1) return

          let currentDiscount = filter(
            type => !!type.value,
            this.discountTypes
          )

          if (!isEmpty(currentDiscount)) {
            currentDiscount[this.discount].value = this.getDiscountValue()
          }

          const allData = clone({
            ...currentDiscount,
            invitationName: this.invitationName,
            paymentType: this.paymentType,
            templateKey: this.templateKey,
            originalPackageId: this.packageId,
            isKillerFeatureEnabled: this.isKillerFeatureEnabled,
            isPaidOffline: this.isPaidOffline,
            package: Object.assign({}, this.currentPackage, this.packageEmailTemplates),
            predefinedActivities: this.invitationPredefinedActivities
          })
          const dataToSend = mapObjIndexed((val, key, obj) => val.hasOwnProperty('value')? val['value'] : val, allData)

          const items = this.selected.map(id => {
            const item = this.getBatchedInvitationsItems.find(i => i.id === id)
            const itemData = Object.assign({}, item, dataToSend)
            return itemData
          })

          const ids = items.map(item => item.id)
          await this.saveBatchedInvitations(items)
          if (action === 'send') {
            await this.sendBatchedInvitations({ ids, templateKey: this.templateKey.value })
          } else {
            await this.reSendBatchedInvitations({ ids, templateKey: this.templateKey.value })
          }
          await this.fetchBatchedInvitations()
          this.selected = []
          // this.clear()
        } catch(err) {
          console.error(err)
        }
      },
      clear () {
        this.$v.$reset()
        this.discountTypes = map(field => {
          const newField = { ...field }
          newField.value = ''
          return newField
        }, this.discountTypes)
        // reset old formData
        this.maxDiscountInCurrency = this.packages[0].price
        this.isKillerFeatureEnabled.value = false
        this.isPaidOffline.value = false
        this.packageId.value = this.packages[0].id
        this.discount = 'discountInCurrency'
        this.selected = []
      },
      convertToNumber (field) {
        if (typeof field === 'string') {
          return isNaN(Number(field)) ? field : Number(field)
        }
        return field
      },
      getDiscountValue () {
        return this.discount === 'discountInPercent'
          ? this.discountTypes[this.discount].value / 100
          : this.discountTypes[this.discount].value
      }
    },
    async created () {
      try {
        const payload = { page: 0, itemsOnPage: 9999 }
        await Promise.all([
          this.getEnabledCategoriesList(),
          this.getPackagesList(),
          this.getPredefinedActivity(),
          this.fetchVIPAttendeeTypes(payload),
          this.getCategoriesList(),
          this.fetchBatchedInvitations()
        ])
        this.loading = false
      } catch (err) {
        console.error(err)
      }
    }
  }
</script>

<style>
.aligned-center td {
  text-align: center;
}

.status-Incomplete {
  background: #ff9800;
}

.edit-popup {
  position: fixed;
  top: 5%;
  left: 5%;
  width: 90%;
  height: 90%;
  background: white;
  padding: 20px;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s ease-out;
  overflow-y: auto;
  z-index: 4;
  border-radius: 5px;
}

.edit-popup-bg {
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}

.visible-popup {
  opacity: 1;
  visibility: visible;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Registration/Invitation/batched.vue